import React from 'react';
export function HowItWorks() {
  const steps = [{
    number: '1',
    title: 'Book Your Clean',
    description: 'Reach out and tell us what you need. Quotes are fast and free.'
  }, {
    number: '2',
    title: 'We Get to Work',
    description: 'Our team arrives on time with everything required to make your space shine.'
  }, {
    number: '3',
    title: 'Enjoy the Sparkle',
    description: 'Come home to a spotless space, guaranteed.'
  }];
  return <section className="py-20 md:py-32 bg-brand-white" data-id="element-163">
      <div className="container mx-auto px-4 md:px-6" data-id="element-164">
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-24" data-id="element-165">
          <h2 className="font-display font-bold text-3xl md:text-4xl lg:text-5xl text-brand-navy mb-4" data-id="element-166">
            How It Works
          </h2>
          <p className="text-lg text-brand-navy/70" data-id="element-167">
            Three simple steps to a spotless home.
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto" data-id="element-168">
          {/* Dashed Connector Line (Desktop Only) */}
          <div className="hidden md:block absolute top-10 left-[10%] right-[10%] h-[2px] border-t-2 border-dashed border-brand-sky/50 z-0" data-id="element-169"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative z-10" data-id="element-170">
            {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center" data-id="element-171">
                <div className="w-20 h-20 rounded-full bg-brand-aqua text-brand-white flex items-center justify-center font-display font-bold text-3xl mb-6 shadow-lg shadow-brand-aqua/20 border-4 border-brand-white" data-id="element-172">
                  {step.number}
                </div>
                <h3 className="font-display font-bold text-2xl text-brand-navy mb-3" data-id="element-173">
                  {step.title}
                </h3>
                <p className="text-brand-navy/70 text-base md:text-lg leading-relaxed max-w-xs" data-id="element-174">
                  {step.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}